import { Pipe, PipeTransform } from '@angular/core';
import { environment } from '@environments/environment';
import { ENVIRONMENTS } from '@shared/constants';

@Pipe({
  standalone: true,
  name: 'daysLeft',
})
export class DaysLeftPipe implements PipeTransform {
  transform(value: string | Date): string {
    if (environment.env === ENVIRONMENTS.PLAYWRIGHT) {
      return '10';
    }
    const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
    const startDate = new Date();
    const endDate = new Date(value);

    const difference = endDate.getTime() - startDate.getTime();

    if (difference <= 0) {
      return `0`;
    }

    return `${Math.ceil(difference / oneDay)}`;
  }
}
